module.exports = __webpack_public_path__ + "static/media/point-break.40673cd9.png";